<template>
  <div class="layout">
    <!-- <download-file
      :isShowDownloadIcon="true"
      :title="$t('HSInspectManageMat.t44')"
      uatId="17254bc8de89869cf6494e9452094469"
      proId="17254bda80b000381c77a3e44228ac98"
    ></download-file> -->
    <Tabs type="card" @on-click="tabClick">
      <!-- 待处理 -->
      <TabPane :label="$t('HSInspectManageMat.t45')" name="1">
        <m-assembly-table
          :total="total"
          :loading="loading"
          :formData="formData"
          :columns="columns"
          :data="data"
          :settings="settings"
          :tableButtons="tableButtons"
          @onSubmit="onSubmit"
          @onPageSizeChange="onPageSizeChange"
          @onCurrentPageChange="onCurrentPageChange"
          @on-select="onSelection"
          @on-select-cancel="onSelectionCancel"
          @on-select-all="onSelectionAll"
          @onSelectionChange="onSelectionChange"
          ref="HSInspectTable1"
        >
          <!-- <span slot="buttonRight" style="color:red;margin-left:20px;">提示：如已有有效报告（报告有效期大于30天），请点击“流程编码”填写内容;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如还没有有效报告(含报告有效期30天内)，请填写“报告计划完成日期”一栏并提交</span> -->
          <span slot="buttonRight" style="color: red; margin-left: 20px">{{
            $t("HSInspectManageMat.t47")
          }}</span>
        </m-assembly-table>
      </TabPane>
      <!-- 已处理 -->
      <TabPane :label="$t('HSInspectManageMat.t46')" name="2">
        <m-assembly-table
          :total="total2"
          :loading="loading2"
          :formData="formData2"
          :columns="columns2"
          :settings="settings2"
          :data="data2"
          @onSubmit="onSubmit2"
          @onPageSizeChange="onPageSizeChange2"
          @onCurrentPageChange="onCurrentPageChange2"
          ref="HSInspectTable2"
        >
          <div slot="tableHeader">
            <div style="overflow: hidden">
              <div style="float: left">
                <set-table
                  :columns="columns2.columns"
                  @setTableUpdate="setTableUpdate2"
                ></set-table>
              </div>
            </div>
          </div>
        </m-assembly-table>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import axios from "axios";
import mAssemblyTable from "@/components/awesome/page/assembly_table/index.js";
import { switchLanguageToQms } from '@/utils/tool';
export default {
  name: "HSInspectManageMaterial",
  components: {
    mAssemblyTable,
  },
  watch: {
    cacheSelection: function () {
      if (this.cacheSelection.length === 0) {
        this.tableButtons.customButtons[0].disabled = true;
      } else {
        this.tableButtons.customButtons[0].disabled = false;
      }
    },
  },
  data() {
    return {
      chooseTab: "1",
      page: 1,
      page2: 1,
      pageSize: 10,
      pageSize2: 10,
      total: 0,
      total2: 0,
      loading: false,
      loading2: false,
      formData: {
        row: 1,
        items: [
          {
            value: "",
            field: "divId",
            layout: {
              span: 8,
              offset: 0,
              row: 1,
            },
            options: {
              multiple: false,
              values: [],
            },
            validators: {
              required: {
                  required: true,
                  message: this.$t("groupStop.t5")
              }
            },
            type: "select",
            title: this.$t("HSInspectManageMat.t41"), // '事业部'
          },
        ],
      },
      formData2: {
        row: 1,
        items: [
          {
            value: "",
            field: "divId",
            layout: {
              span: 8,
              offset: 0,
              row: 1,
            },
            options: {
              multiple: false,
              values: [],
            },
            type: "select",
            title: this.$t("HSInspectManageMat.t41"), //'事业部',
            validators: {
              required: {
                  required: true,
                  message: this.$t("groupStop.t5")
              }
            },
          },
          {
            value: "",
            field: "AUDIT_DATE_BEGIN",
            type: "datePicker",
            title: this.$t("HSInspectManageMat.t4"), // '报告完成日期',
            style: "width: 100%;",
            layout: {
              row: 1,
              span: 8,
              offset: 0,
            },
            options: {
              type: "date",
              format: "yyyy-MM-dd",
            },
            // validators: {
            //     required: {
            //         required: true,
            //         message: '报告完成开始日期不能为空'
            //     }
            // },
            isDouble: true,
          },
          {
            hide: true,
            value: "",
            field: "AUDIT_DATE_END",
            type: "datePicker",
            title: "",
            style: "width: 100%;",
            layout: {
              row: 1,
              span: 8,
              offset: 0,
            },
            options: {
              type: "date",
              format: "yyyy-MM-dd",
            },
            // validators: {
            //     required: {
            //         required: true,
            //         message: '报告完成结束日期不能为空'
            //     }
            // }
          },
        ],
      },
      cacheSelection: [],
      tableButtons: {
        systemButtons: [],
        customButtons: [
          {
            name: "",
            label: this.$t("HSInspectManageMat.t34"), // '提交',
            type: "primary",
            icon: "ios-down",
            loading: false,
            disabled: true,
            click: () => {
              this.beforeUpdate();
            },
          },
        ],
      },
      columns: {
        columns: [
          {
            title: "选择",
            type: "selection",
            align: "center",
            width: 40,
          },
          {
            title: this.$t("HSInspectManageMat.t22"), // '流程编码',
            key: "REPORT_NO",
            minWidth: 150,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "blue",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: "HSInspectManageMaterialDetail",
                        query: {
                          REPORT_NO: params.row.REPORT_NO,
                          DIV_ID: this.getFormDataItemVal(
                            this.formData.items,
                            "divId"
                          ),
                          WORKFLOW_STATUS: "Draft",
                          ID: params.row.ID,
                          // DIV_ID: '582'
                        },
                      });
                    },
                  },
                },
                params.row.REPORT_NO
              );
            },
          },
          {
            title: this.$t("HSInspectManageMat.t16"), // '流程状态',
            key: "WORKFLOW_STATUS",
            minWidth: 70,
          },
          {
            title: this.$t("HSInspectManageMat.t30"), // '驳回次数',
            key: "REJECT_COUNT",
            align: "center",
            width: 60,
            render: (h, params) => {
              return h(
                "b",
                {
                  style: {
                    color: "red",
                  },
                },
                params.row.REJECT_COUNT
              );
            },
          },
          {
            title: this.$t("HSInspectManageMat.t8"), // '驳回原因',
            key: "REASON",
            minWidth: 200,
            render: (h, params) => {
              return h(
                "b",
                {
                  style: {
                    color: "red",
                  },
                },
                params.row.REASON
              );
            },
          },
          {
            renderHeader: (h, params) => {
              return h("span", {}, [
                h(
                  "span",
                  {
                    style: {
                      color: "#ff0000",
                    },
                  },
                  ["* "]
                ),
                h("span", {}, [this.$t("HSInspectManageMat.t4")]),
              ]);
            },
            title: this.$t("HSInspectManageMat.t4"), // '报告计划完成日期',
            key: "SUPPLIER_SUBMIT_DATE_TL",
            align: "center",
            minWidth: 130,
            render: (h, params) => {
              return h("div", [
                h("DatePicker", {
                  props: {
                    value: params.row.SUPPLIER_SUBMIT_DATE_TL,
                    format: "yyyy-MM-dd", // yyyy-MM-dd HH:mm:ss
                    type: "date", // month
                    placement: "top",
                    transfer: true,
                    size: "small",
                    clearable: true,
                    options: {
                      disabledDate: (date) => {
                        return date && date.valueOf() < Date.now() - 86400000;
                      },
                    },
                  },
                  on: {
                    "on-clear": (event) => {
                      params.row.SUPPLIER_SUBMIT_DATE_TL = event || "";
                      this.data[params.index] = params.row;
                    },
                    "on-change": (event) => {
                      params.row.SUPPLIER_SUBMIT_DATE_TL = event;
                      this.data[params.index] = params.row;
                    },
                  },
                  style: {
                    width: "120px",
                    padding: "1px",
                  },
                }),
              ]);
            },
          },
          {
            title: this.$t("HSInspectManageMat.t14"), // '有效期倒计时(天)',
            key: "EXPIRATIONDATE_REC",
            align: "center",
            minWidth: 60,
          },
          {
            title: this.$t("HSInspectManageMat.t28"), // '报告有效期',
            key: "EXPIRATION_DATE_TL",
            align: "center",
            minWidth: 130,
          },
          {
            title: this.$t("HSInspectManageMat.t23"), // '大类',
            key: "BIG_CLASS_NAME",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t24"), // '中类',
            key: "MID_CLASS_NAME",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t25"), // '小类',
            key: "SMALL_CLASS_NAME",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t40"), // '材质',
            key: "MATERIAL_NAME",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t41"), // '事业部',
            key: "DIV_NAME",
            minWidth: 120,
            render: (h, params) => {
              return h(
                "Tooltip",
                {
                  props: {
                    content: params.row.DIV_NAME,
                    placement: "top",
                  },
                  class: "m-tooltip-overflow",
                },
                params.row.DIV_NAME
              );
            },
          },
          {
            title: this.$t("HSInspectManageMat.t42"), // '管控类型',
            key: "CONTROL_TYPE_TL",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t27"), // '报告编码',
            key: "REPORT_CODE",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t11"), // '报告类型',
            key: "REPORT_TYPE_TL",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t5"), // '检测机构',
            key: "FEELER_MECHANISM",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t3"), // '报告日期',
            key: "REPORT_DATE_TL",
            align: "center",
            minWidth: 130,
            render: (h, params) => {
              return h(
                "span",
                {},
                params.row.REPORT_DATE_TL === "0001-01-01 00:00:00"
                  ? ""
                  : params.row.REPORT_DATE_TL
              );
            },
          },
          {
            title: this.$t("HSInspectManageMat.t19"), // '报告提交日期',
            key: "SUBMIT_DATE_TL",
            align: "center",
            minWidth: 130,
          },
          {
            title: this.$t("HSInspectManageMat.t15"), // '报告结论',
            key: "CHECKED_RESULT_TL",
            width: 100,
          },
          // {
          //   title: '审核人',
          //   key: 'AUDITOR_TL',
          //   width: 100
          // },
          {
            title: this.$t("HSInspectManageMat.t29"), // '审核时间',
            key: "AUDIT_DATE_TL",
            align: "center",
            minWidth: 130,
          },
          {
            title: this.$t("HSInspectManageMat.t31"), // '发布人',
            key: "PUBLISH_NAME",
            align: "center",
            minWidth: 100,
          },
        ],
      },
      cacheSelection2: [],
      columns2: {
        columns: [
          {
            title: this.$t("HSInspectManageMat.t22"), // '流程编码',
            key: "REPORT_NO",
            minWidth: 150,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "blue",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: "HSInspectManageMaterialDetail",
                        query: {
                          REPORT_NO: params.row.REPORT_NO,
                          DIV_ID: this.getFormDataItemVal(
                            this.formData2.items,
                            "divId"
                          ),
                          WORKFLOW_STATUS: "Approve,Approving",
                          ID: params.row.ID,
                        },
                      });
                    },
                  },
                },
                params.row.REPORT_NO
              );
            },
          },
          {
            title: this.$t("HSInspectManageMat.t16"), // '流程状态',
            key: "WORKFLOW_STATUS",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t23"), // '大类',
            key: "BIG_CLASS_NAME",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t24"), // '中类',
            key: "MID_CLASS_NAME",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t25"), // '小类',
            key: "SMALL_CLASS_NAME",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t40"), // '材质',
            key: "MATERIAL_NAME",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t41"), // '事业部',
            key: "DIV_NAME",
            minWidth: 120,
            render: (h, params) => {
              return h(
                "Tooltip",
                {
                  props: {
                    content: params.row.DIV_NAME,
                    placement: "top",
                  },
                  class: "m-tooltip-overflow",
                },
                params.row.DIV_NAME
              );
            },
          },
          {
            title: this.$t("HSInspectManageMat.t42"), // '管控类型',
            key: "CONTROL_TYPE_TL",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t27"), // '报告编码',
            key: "REPORT_CODE",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t11"), // '报告类型',
            key: "REPORT_TYPE_TL",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t5"), // '检测机构',
            key: "FEELER_MECHANISM",
            minWidth: 100,
          },
          {
            title: this.$t("HSInspectManageMat.t4"), // '报告计划完成日期',
            key: "SUPPLIER_SUBMIT_DATE_TL",
            align: "center",
            minWidth: 130,
          },
          {
            title: this.$t("HSInspectManageMat.t3"), // '报告日期',
            key: "REPORT_DATE_TL",
            align: "center",
            minWidth: 130,
            render: (h, params) => {
              return h(
                "span",
                {},
                params.row.REPORT_DATE_TL === "0001-01-01 00:00:00"
                  ? ""
                  : params.row.REPORT_DATE_TL
              );
            },
          },
          {
            title: this.$t("HSInspectManageMat.t28"), // '报告有效期',
            key: "EXPIRATION_DATE_TL",
            align: "center",
            minWidth: 130,
          },
          {
            title: this.$t("HSInspectManageMat.t14"), // '有效期倒计时(天)',
            key: "EXPIRATIONDATE_REC",
            align: "center",
            minWidth: 60,
          },
          {
            title: this.$t("HSInspectManageMat.t19"), // '报告提交日期',
            key: "SUBMIT_DATE_TL",
            align: "center",
            minWidth: 130,
          },
          {
            title: this.$t("HSInspectManageMat.t15"), // '报告结论',
            key: "CHECKED_RESULT_TL",
            align: "center",
            minWidth: 150,
          },
          // {
          //   title: '审核人',
          //   key: 'AUDITOR_TL',
          //   minWidth: 150
          // },
          {
            title: this.$t("HSInspectManageMat.t29"), // '审核时间',
            key: "AUDIT_DATE_TL",
            align: "center",
            minWidth: 130,
          },
          {
            title: this.$t("HSInspectManageMat.t8"), // '驳回原因',
            key: "REASON",
            minWidth: 200,
          },
        ],
      },
      data: [],
      data2: [],
      // vendorCode: "",
      settings: {
        needPager: true,
        showElevator: true,
        showSizer: true,
        pageSizeOpts: [10, 30, 50, 80],
        needSearch: true,
        needValidation: true,
        needSetTable: true,
      },
      settings2: {
        needPager: true,
        showElevator: true,
        showSizer: true,
        pageSizeOpts: [10, 30, 50, 80],
        needSearch: true,
        needValidation: true,
      },
      mdmCode: ''
    };
  },
  methods: {
    queryVendorAndMdm() {
      axios.post('/gscint/vendor/queryVendorAndMdm', {
        vendorCode: this.vendorCode
      }).then((res) => {
        this.mdmCode = res.data.data.datas.mdmCode;
        // debugger
      });
    },
    tabClick(name) {
      this.chooseTab = name;
    },
    search(formName) {
      if (this.$refs[formName].$children[0].$children[0].validateForm()) {
        if (formName === "HSInspectTable1") {
          this.loading = true;
        } else {
          this.loading2 = true;
        }
        let params = {
          ID: "", // (HS检验报告ID)  -- 非必填
          REPORT_NO: "", // (流程编号)   --非必填
          SUPPLIER_CODES: this.mdmCode, // A000001(供应商编码) --非必填
          DIV_ID:
            formName === "HSInspectTable1"
              ? this.getFormDataItemVal(this.formData.items, "divId")
              : this.getFormDataItemVal(this.formData2.items, "divId"), // (事业部ID) --非必填
          WORKFLOW_STATUS:
            formName === "HSInspectTable1" ? "Draft" : "Approve,Approving", // (流程状态)(Draft：起草，Approve：已审核，Approving：审核中)--非必填
          USER_MODIFIED: "", // (填写人账号) --非必填
          CONTROL_TYPE: "", //   --非必填  (AllItems:全项，Replenish：补充)
          PAGESIZE:
            formName === "HSInspectTable1" ? this.pageSize : this.pageSize2, // (每页显示的记录数) --非必填(默认值：30)
          PAGEINDEX: formName === "HSInspectTable1" ? this.page : this.page2, // (当前页页码)   --非必填(默认值：1)
          DataType: "Page", // (取数操作类型（NoPage:不分页获取全部数据，Page:分页查询）)  --非必填(默认值：Page)
          AUDIT_DATE_BEGIN:
            formName === "HSInspectTable1"
              ? undefined
              : `${this.getFormDataItemVal(
                  this.formData2.items,
                  "AUDIT_DATE_BEGIN"
                )}`,
          AUDIT_DATE_END:
            formName === "HSInspectTable1"
              ? undefined
              : `${this.getFormDataItemVal(
                  this.formData2.items,
                  "AUDIT_DATE_END"
                )}`,
         LANGUAGE: switchLanguageToQms(this.$i18n.locale),
        };
        axios({
          // url: '/qms2gsc/hsReport/GetMaterialReportListForeign',
          url: '/gscint/hsCheck/GetMaterialReportList',
          method: 'post',
          data: params,
        })
          .then((res) => {
            console.log('000');
            
            // let resp = JSON.parse(res.data.substring(1).substring(0, res.data.length - 3));
            // console.log('res---', resp);
            // if (formName === "HSInspectTable1") {
            //   this.loading = false;
            // } else {
            //   this.loading2 = false;
            // }
            // if (resp.IsSucess) {
            //   if (formName === "HSInspectTable1") {
            //     this.data = resp.MainResultData.DATA;
            //     this.total = resp.MainResultData.TOTAL;
            //   } else {
            //     this.data2 = resp.MainResultData.DATA;
            //     this.total2 = resp.MainResultData.TOTAL;
            //   }
            // } else {
            //   this.$Modal.error({
            //     title: this.$t("HSInspectManageMat.t48"),
            //     content: this.$t("HSInspectManageMat.t49"),
            //   });
            // }
            if (formName === 'HSInspectTable1') {
              this.loading = false;
            } else {
              this.loading2 = false;
            }
            if (res.data.data.success) {
              if (formName === 'HSInspectTable1') {
                this.data = res.data.data.datas.MainResultData.DATA;
                this.total = res.data.data.datas.MainResultData.TOTAL;
              } else {
                this.data2 = res.data.data.datas.MainResultData.DATA;
                this.total2 = res.data.data.datas.MainResultData.TOTAL;
              }
            } else {
              this.$Modal.error({
                title: this.$t("HSInspectManageMat.t48"),
                content: this.$t("HSInspectManageMat.t49"),
              });
            }
          })
          .catch(() => {
            if (formName === 'HSInspectTable1') {
              this.loading = false;
            } else {
              this.loading2 = false;
            }
            this.$Modal.error({
              title: this.$t("HSInspectManageMat.t48"),
              content: this.$t("HSInspectManageMat.t49"),
            });
          });
      }
    },
    onSubmit() {
      // console.log(this.$refs.HSInspectTable1);
      this.search("HSInspectTable1");
    },
    onPageSizeChange(page, pageSize) {
      this.page = 1;
      this.pageSize = pageSize;
      this.onSubmit();
    },
    onCurrentPageChange(page) {
      this.page = page;
      this.onSubmit();
    },
    onSelection(selection, row) {
      console.log("onSelection,row::", selection, row);
    },
    onSelectionCancel(selection, row) {
      this.cacheSelection = selection;
      for (let i = 0; i < this.cacheSelection.length; i++) {
        this.cacheSelection[i]["_checked"] = true;
      }
    },
    onSelectionAll(selection) {
      console.log("onSelectionAll::", selection);
    },
    /** 选择框改变时触发 */
    onSelectionChange(selection, row) {
      this.cacheSelection = selection;
      for (let i = 0; i < this.cacheSelection.length; i++) {
        this.cacheSelection[i]["_checked"] = true;
      }
    },
    /** 提交前验证
     *  参数：ID(查询返回)   REPORT_NO(查询返回)    SUPPLIER_SUBMIT_DATE(系统当前时间)
     * **/
    beforeUpdate() {
      let param = [];
      this.cacheSelection.forEach((val) => {
        this.data.map((item) => {
          if (val.REPORT_NO === item.REPORT_NO) {
            console.log("item::", item);
            let obj = {
              ID: item.ID,
              REPORT_NO: item.REPORT_NO,
              SUPPLIER_SUBMIT_DATE: item.SUPPLIER_SUBMIT_DATE_TL,
              HsType: "Material",
              DIV_ID: this.getFormDataItemVal(this.formData.items, "divId"),
            };
            param.push(obj);
          }
        });
      });
      let url = '/gscint/hsCheck/updateSupplierDate'; // "/gscapp/hsCheck/updateSupplierDate";
      axios({
        url: url,
        method: 'post',
        data: param
      })
        .then((res) => {
          let returnVal = res.data.data.datas;
          console.log('returnVal', returnVal);
          if (!returnVal) {
            this.$Message.success({
              content: this.$t("HSInspectManageMat.t43"), // '提交成功',
              width: 500,
              duration: 3,
            });
          } else {
            let data = returnVal.split(";");
            let content = "";
            data.forEach((item) => {
              item = item.split(" ");
              if (item[2]) {
                content += `${item[0]} ${item[1]} ，${
                  JSON.parse(
                    item[2].substring(1).substring(0, item[2].length - 2)
                  ).MESSAGE
                } <br>`;
              }
            });
            this.$Modal.warning({
              title: this.$t("HSInspectManageMat.t48"),
              content: content,
            });
            return false;
          }
        })
        .catch(() => {
          this.$Modal.error({
            title: this.$t("HSInspectManageMat.t48"),
            content: this.$t("HSInspectManageMat.t49"),
          });
        });
      // axios
      //   .post(url, param)
      //   .then((res) => {
      //     let returnVal = res.data;
      //     if (!returnVal) {
      //       this.$Message.success({
      //         content: this.$t("HSInspectManageMat.t43"), // '提交成功',
      //         width: 500,
      //         duration: 3,
      //       });
      //     } else {
      //       let data = returnVal.split(";");
      //       let content = "";
      //       data.forEach((item) => {
      //         item = item.split(" ");
      //         if (item[2]) {
      //           content += `${item[0]} ${item[1]} ，${
      //             JSON.parse(
      //               item[2].substring(1).substring(0, item[2].length - 2)
      //             ).MESSAGE
      //           } <br>`;
      //         }
      //       });
      //       this.$Modal.warning({
      //         title: this.$t("HSInspectManageMat.t48"),
      //         content: content,
      //       });
      //       return false;
      //     }
      //   })
      //   .catch(() => {
      //     this.$Modal.error({
      //       title: this.$t("HSInspectManageMat.t48"),
      //       content: this.$t("HSInspectManageMat.t49"),
      //     });
      //   });
    },
    onSubmit2() {
      this.search("HSInspectTable2");
    },
    onPageSizeChange2(page, pageSize) {
      this.page2 = 1;
      this.pageSize2 = pageSize;
      this.onSubmit2();
    },
    onCurrentPageChange2(page) {
      this.page2 = page;
      this.onSubmit2();
    },
    /* 快码CUX_HS_MATERIAL_SET => INT_HS_MATERIAL_SET，条目值为SRM的事业部ID */
    getOrgs() {
    //   axios
    //     .get(
    //       "/gscint/sys/sysParam/queryDictionaryData?dictCode=INT_HS_MATERIAL_SET&isValid=Y"
    //     )
    //     .then((res) => {
    //       let data = res.data.data;
    //       if (data.length > 0) {
    //         let newData = [];
    //         data.map(({ value, label }) => {
    //           newData.push({
    //             label: label,
    //             value: value,
    //           });
    //         });
    //         this.formData.items[0].options.values = newData;
    //         this.formData2.items[0].options.values = newData;
    //       }
    //     });
        axios.get('/gscint/vendor/getOverSeaBuList', {
            params: {
                SITE: 'Y',
                ASL: 'N',
            }
        })
            .then((res) => {
                const data = res.data.data.datas;
                data.forEach((item) => {
                    item.label = item.buName;
                    item.value = item.qmsId;
                });
                this.getFormDataItemObj(this.formData.items, 'divId').options.values = data;
                this.getFormDataItemObj(this.formData2.items, 'divId').options.values = data;
            })
    },
    setTableUpdate2(columns) {
      this.columns2.columns = columns;
    },
  },
  mounted() {
    this.getOrgs();
    this.queryVendorAndMdm();
  },
  activated() {
    // if (this.chooseTab === "1") {
    //   this.onSubmit();
    // } else {
    //   this.onSubmit2();
    // }
  },
};
</script>
<style lang="less" scoped>
.layout {
  background: #fff;
  padding: 10px;
}
</style>
